<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <div class="rowStyle" style="font-weight: bold;">客服能给您提供以下服务:</div>
          <div class="rowStyle">1.远程(用QQ远程协助)教您如何使用本系统;</div>
          <div class="rowStyle">2.帮您导入成绩;</div>
          <div class="rowStyle">3.给客服提软件需求，如果需求有共性，开发人员会按照您的想法开发出来;</div>
        </div>
        <div>
          <div class="rowStyle" style="font-weight: bold;">以下方式可以联系到小客服同学:</div>
          <div class="rowStyle">方式一快查成绩手机端小程序上直接点左下角的客服在线图标</div>
          <div class="rowStyle">方式二加QQ客服群：790821093 </div>
          <div class="rowStyle">方式三加客服个人微信号：wx34424698 </div>
          <div class="rowStyle">方式四加客服个人QQ：34424698 </div>
          <div class="rowStyle">注：如果没有响应，请耐心等待，小客服可能在开会或者开小差，但一定会解决您的问题。</div>
          <!-- <div @click="helpme"> 联系客服 </div> -->
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {}
    },
    created() {},
    methods: {
      helpme() {
        window.open('http://wpa.qq.com/msgrd?v=3&uin=34424698&site=qq&menu=yes', '_brank')
      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    margin: 20px;
    font-size: 16px;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }
</style>



// WEBPACK FOOTER //
// src/components/connect_service.vue